import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    support: null,
    downloadDetail: null,
  },

  mutations: {
    CLEAR_ALL(state) {
      state.support = null;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_BU_SUPPORT(state, data) {
      state.support = data;
    },
    INIT_DOWNLOAD_DETAIL(state, detail) {
      state.downloadDetail = detail;
    },
    SET_DOWNLOAD_DETAIL(state, detail) {
      if (!state.support.downloads) {
        state.support.downloads = [];
      }

      if (detail.id) {
        const index = state.support.downloads.map((i) => i.id).indexOf(detail.id);
        state.support.downloads[index] = detail;
      } else {
        state.support.downloads.push(detail);
      }
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    initDownloadDetail({ commit }, detail) {
      commit('INIT_DOWNLOAD_DETAIL', detail);
    },

    setDownloadDetail({ commit }, detail) {
      commit('SET_DOWNLOAD_DETAIL', detail);
    },

    find({ commit, state }) {
      let url = `/product_downloads?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('ProductDownload'));
          return response.body;
        })
        .then((response) => {
          commit('SET_DOWNLOADS', response);
        });
    },

    findById({ commit }, id) {
      return http(`/supports/${id}`)
        .then((response) => response.body)
        .then(typeAs('Support'))
        .then((item) => {
          commit('SET_BU_SUPPORT', item);
        });
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/supports/${id}`, { method: 'PUT', data })
        : http('/supports', { method: 'POST', data });

      return request.then((response) => response.body);
    },

    sections() {
      return http('/support_sections')
        .then((response) => response.body);
    },
  },
};
